import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const IDLE_TIMEOUT = 10 * 60 * 1000; // 15 minutes in ms

export default function useIdleLogout() {
  const navigate = useNavigate();

  useEffect(() => {
    let timeout;

    const resetTimer = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        // logout automatically
        localStorage.clear();
        navigate('/user-login'); 
      }, IDLE_TIMEOUT);
    };

    // List of events that count as activity
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];

    events.forEach(ev => window.addEventListener(ev, resetTimer));

    // initialize timer
    resetTimer();

    return () => {
      clearTimeout(timeout);
      events.forEach(ev =>
        window.removeEventListener(ev, resetTimer)
      );
    };
  }, [navigate]);
}
